export function truncateTimestampForApi(timestamp: string | null | undefined): string {
  const parts = (timestamp || '').split('.');
  return parts.length > 1 ? parts[0] + 'Z' : parts[0];
}
